import React from 'react';

const PostTripProcess = {
  title: 'Post-Trip Process',
  items: [
    {
      header: 'What do I have to do after the trip ends?',
      content: (
        <div>
          <p>After your trip ends, you may ask the traveler for their reservation code, or take a selfie with them and submit it. This will take 3 business days to be approved.</p>
          <p>We also suggest you encourage your traveler to leave a review as well.</p>
        </div>
      )
    },
    {
      header: 'What should I do if I did not receive the money?',
      content: (
        <div>
          <p>Please check <a href="https://www.takemetour.com/dashboard/wallet">your Wallet</a> for your money transfer method.</p>
          <p>If you select Manual-transfer, you may have to make a request before Monday midnight to receive money on coming Wednesday.</p>
          <p>If you already make a request or select Auto-transfer, the money will be transferred to your bank account before Wednesday midnight.</p>
          <p>Please also note that the amount of money that you can transfer should be released into your Wallet before Monday midnight every week.</p>
          <p>If you still don’t receive the money, please contact us at <a href="mailto:support@takemetour.com">support@takemetour.com</a></p>
        </div>
      )
    },
    {
      header: 'What are the differences between Manual-transfer and Auto-transfer?',
      content: (
        <div>
          <p>Manual-transfer will transfer the balance upon your request. Your request must be made before Monday midnight in order to receive money on coming Wednesday. Please also note that the amount of money that you can transfer should be released into your Wallet before Monday midnight every week. If you make a request later than that, the system will transfer the balance the next Wednesday. This is suitable for people who don’t want to pay the transaction fee too often.</p>
          <p>Auto-transfer will automatically transfer the balance on coming Wednesday. This is suitable for people who would like the earnings transferred to their bank account every week. </p>
          <p>Note: For KBank users, free transaction is available once a month. For the rest of the month, there will be 30 THB fee per transaction).</p>
          <p>For other banks, there will be 50 THB fee per transaction.</p>
        </div>
      )
    },
    {
      header: 'Where do I find the payout information?',
      content: (
        <div>
          <p>You can find your payout information in <a href="https://www.takemetour.com/dashboard/wallet">your Wallet at Wallet</a> Statement.</p>
        </div>
      )
    }
  ]
};

export default PostTripProcess;
